/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { encryptionKeys } from '../core/constants/keys.constant';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  // TODO
  secretKey: any = 'xplora-luxe';

  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  iv = CryptoJS.enc.Base64.parse(encryptionKeys.IV); // giving empty initialization vector
  key = CryptoJS.SHA256(encryptionKeys.key); // hashing the key using SHA256
  encryptedString: any;
  encryptionPayload(data: any): any {
    data = data.slice();
    this.encryptedString = CryptoJS.AES.encrypt(data, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return this.encryptedString.toString();
  }

  encryptLocalStorage(data: any, key: string):any {
    const encyrpted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.secretKey
    ).toString();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, encyrpted);
    }
  }

  encryptHeaders(data: any, type = 'header'): any {
    if (typeof data === 'string') {
      data = data.slice();
      this.encryptedString = CryptoJS.AES.encrypt(data, this.key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    } else {
      this.encryptedString = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        this.key,
        {
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );
    }

    if (type === 'query' && this.encryptedString.toString().includes('+')) {
      this.encryptedString = this.encryptedString
        .toString()
        .split('+')
        .join(environment.storageKey);
    }

    return this.encryptedString.toString();
  }
}
